import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import { ICustomerDetailsForm } from "../CustomerDetailsForm";
import { format, parse } from "date-fns";

export const formatUserDate = (date: string) => format(parse(date, "yyyy-MM-dd", new Date()), "MM/yyyy");

export const getCustomerDetailsRequest = (
    formData: ICustomerDetailsForm,
    customerDetails: ICustomerDetails,
    isAuthenticated: boolean
): ICustomerDetails => {
    const parsedBirthDate = isAuthenticated
        ? parse(customerDetails.owner.person.birthDate, "yyyy-MM-dd", new Date())
        : parse("01/" + formData.birthDate, "dd/MM/yyyy", new Date());
    const birthDateFormatted = format(parsedBirthDate, "yyyy-MM-dd");

    const billingAddress = isAuthenticated
        ? customerDetails.billingAddress
        : {
              postalCode: formData.billingAddress.postalCode,
              city: formData.billingAddress.city,
              area: formData.billingAddress.area,
              street: formData.billingAddress.street,
              buildingName: formData.billingAddress.buildingName,
              buildingType: formData.billingAddress.buildingType,
              streetQualifier: formData.billingAddress.streetQualifier,
              streetNumber: formData.billingAddress.streetNumber,
              postalBox: formData.billingAddress.postalBox,
              enablePostalBox: formData.billingAddress.enablePostalBox,
              flatNumber: formData.billingAddress.flatNumber,
          };

    const owner = isAuthenticated
        ? customerDetails.owner
        : {
              email: formData.email || "",
              communicationLanguage: formData.communicationLanguage || "",
              privacyPolicy: formData.privacyPolicy,
              precontractualTerms: formData.precontractualTerms,
              permissions: formData.permissions === "YES" ? true : false,
              mobileNumber: formData.mobileNumber || undefined,
              person: {
                  birthDate: birthDateFormatted,
                  identificationNumber: formData.identificationNumber,
                  firstName: formData.firstName || "",
                  lastName: formData.lastName || "",
              },
          };

    return {
        billingAddress,
        owner,
    };
};
